module.exports = __webpack_public_path__ + "static/sample-projects-15-9758a618b51cf621bed51374ddcd878c.png";